import {
  IConveyorBoxItemUI,
  IRxBoxItem,
  ISku,
  Picks,
} from "../../lib/interfaces/ConveyorBox/IConveyorBox";
import { LimaOrderStatus } from "../Constants";

export const getItemsByIdentifier = (
  identifier: string,
  items: IConveyorBoxItemUI[] = []
): IConveyorBoxItemUI[] => {
  const parsedId = Number(identifier);

  return items.filter(
    (item) =>
      item.sku.ean === identifier ||
      (!isNaN(parsedId) && item.sku.id === parsedId) ||
      item.varunummer === identifier ||
      (identifier.length > 16 && identifier.includes(item.sku.ean.trim())) ||
      item.sku.barcodes.some((barcode) => identifier.includes(barcode.trim()))
  );
};

export function getItemByIdentifier<
  T extends {
    id: number;
    varunummer: IRxBoxItem["varunummer"];
    sku: ISku;
  }
>(items: T[], identifier: string): T | undefined {
  return items.find(
    (i) =>
      i.sku.ean === identifier ||
      i.sku.id === parseInt(identifier) ||
      i.id === parseInt(identifier) ||
      i.varunummer === identifier ||
      (identifier.length > 16 && identifier.includes(i.sku.ean.trim())) ||
      i.sku.barcodes.some((barcode) => identifier.includes(barcode.trim()))
  );
}

export const getItemsPendingVerification = (items: IConveyorBoxItemUI[]) => {
  return items.filter((item) => item.verifiedQuantity < item.pickedQuantity);
};

export const getBagsPendingVerification = (items: IConveyorBoxItemUI[]) => {
  return items.filter((item) => item.verifiedQuantity < item.confirmedQuantity);
};

/** ORDER/BOX STATUS UTILITY FUNCTIONS */
export const isItemCancelledFromOrder = ({
  confirmedQuantity,
  status,
}: IConveyorBoxItemUI): boolean => {
  return confirmedQuantity === 0 && status === LimaOrderStatus.Struken;
};

export const isPickableItem = ({ confirmedQuantity, status }: IConveyorBoxItemUI): boolean => {
  return confirmedQuantity > 0 && status <= LimaOrderStatus.Levererad;
};

export const itemHasPicks = ({ pickedQuantity }: IConveyorBoxItemUI): boolean => {
  return pickedQuantity > 0;
};

export const isPickedItem = ({
  confirmedQuantity,
  pickedQuantity,
}: IConveyorBoxItemUI): boolean => {
  return confirmedQuantity <= pickedQuantity;
};

export const isBoxItemVerified = <
  T extends {
    confirmedQuantity: number;
    pickedQuantity: number;
    verifiedQuantity: number;
  }
>({
  confirmedQuantity,
  pickedQuantity,
  verifiedQuantity,
}: T): boolean => {
  return confirmedQuantity < 1 || verifiedQuantity >= pickedQuantity;
};

export const getStructuredBoxItems = (items: IConveyorBoxItemUI[]) => {
  // TEMP SEPERATION OF RX BAGS FROM ITEMS - SHOULD BE DONE IN THE BACKEND EVENTUALLY
  const otc = items.filter((i) => i.orderSkuID === -1 && !i.attributes.includes("RXBAG"));
  const rxBags = items.filter((item) => item.attributes.includes("RXBAG"));

  const bundles = rxBags.map((item) => {
    return {
      ...item,
      id: item.id,
      isFinished: item.deliveredQuantity >= item.confirmedQuantity,
      items: items.filter((i) => i.orderSkuID === item.sku.id),
    };
  });
  return { otc, bundles };
};
